import React from 'react';
import { SegmentedSwitch } from 'components/SegmentedSwitch/SegmentedSwitch';
import style from './AdditionalInfoSwitch.module.scss';

type TInfoMode = 'main' | 'additional';

const infoModeOptions: { value: TInfoMode; translationKey: string }[] = [
	{ value: 'main', translationKey: 'mainInfoButton' },
	{ value: 'additional', translationKey: 'additionallyInfoButton' },
];

interface IProps {
	infoMode: TInfoMode;
	setInfoMode: (infoMode: TInfoMode) => void;
}

export const AdditionalInfoSwitch: React.FC<IProps> = ({ infoMode, setInfoMode }) => (
	<div className={style.container}>
		<SegmentedSwitch
			value={infoMode}
			options={infoModeOptions}
			translationNameSpace="listing"
			testId="AdditionalInfoSwitch"
			onChange={setInfoMode}
		/>
	</div>
);
